// B2a.3 — Render-time helper for the outbound card label.
//
// Pure, client-only, zero-dep. Mirrored from the convention documented
// in api/_prompts/card-noun-en.ts: the server-side allowlist carries
// disambiguator parens ("strength (spiritual)") so Grok has a clean
// selection signal between similar entries; the recipient-facing card
// shows the bare noun ("Prayed for strength"). This file is the strip
// helper.
//
// CROSS-BOUNDARY POSTURE: this is a deliberate mirror of the
// CONVENTION, not of the DATA. The 187-entry CARD_NOUN_LIST and its
// allowlist Set live server-side and never reach the client. Server-
// side validation in api/grok.ts narrows hallucinated values to null
// before the field crosses the wire, so the client renders trusted
// input and never needs the allowlist itself. See rule #4 sub-rule on
// cross-boundary duplication, and codex pass 1 LOW on avoiding a
// client→api/_prompts/ import.

/**
 * Strip the trailing ` (anything)` disambiguator from a card-label
 * string so the recipient-facing render shows the bare noun.
 *
 *   "strength (spiritual)" → "strength"
 *   "breakthrough (financial)" → "breakthrough"
 *   "peace (in society)" → "peace"
 *   "healing" → "healing"   (no parens, no change)
 */
export function stripCardLabelDisambig(label: string): string {
  return label.replace(/\s*\([^)]*\)\s*$/, '');
}
